$(document).ready(()=>{
  checkInput()
  validForm()
  validFormResetPassword()
});

const checkInput = () => {
  $('#loginform .input').on('keyup change', (e) => {
    if($(e.currentTarget).val()) {
      $(e.currentTarget).parent().addClass('is-ok')
    } else {
      $(e.currentTarget).parent().removeClass('is-ok')
    }
  })
}

const validForm = () => {
  $('#loginform .input').on('keyup change', (e) => {
    if($('#user_login').val() && $('#user_pass').val()) {
      $('#wp-submit').addClass('is-ok').attr('disabled', false)
    } else {
      $('#wp-submit').removeClass('is-ok').attr('disabled', true)
    }
  })
}

const validFormResetPassword = () => {
  console.log('1')
  if($('#user_email').length){
    $('#loginform .input').on('keyup change', (e) => {
      if($('#user_login').val() && $('#user_email').val()) {
        $('#wp-submit').addClass('is-ok').attr('disabled', false)
      } else {
        $('#wp-submit').removeClass('is-ok').attr('disabled', true)
      }
    })
  }
}